import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const LockOpenFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function LockOpenFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M8.5 9.26v-1.5a3.504 3.504 0 0 1 6.32-2.08l2.41-1.79A6.54 6.54 0 0 0 12 1.25c-3.58 0-6.5 2.92-6.5 6.5v1.5h-2v8.5c0 2.76 2.24 5 5 5h7c2.76 0 5-2.24 5-5v-8.5h-12v.01Zm4.5 7.5c0 .55-.45 1-1 1s-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default LockOpenFilled;